// Copyright (C) 2019-2022 Intel Corporation
//
// SPDX-License-Identifier: MIT

module.exports = {
    backendAPI: '/api',
    proxy: false,
    organizationID: null,
    origin: '',
    uploadChunkSize: 100,
};
